import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

import styles from './ChartCard.module.css';

export interface ChartCardProps {
  title: string;
  subtitle?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  height?: number;
}

/**
 * Standardised wrapper for any chart in Dashboard.
 * Provides title + subtitle + fixed-height body so Recharts'
 * ResponsiveContainer has a stable parent.
 */
export function ChartCard({ title, subtitle, action, children, height = 220 }: ChartCardProps) {
  const { t } = useTranslation([
    'common',
    'nav',
    'board',
    'articles',
    'analytics',
    'feeddrive',
    'config',
    'strategist',
  ]);
  void t;
  return (
    <article className={styles.root}>
      <header className={styles.head}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {action && <div className={styles.action}>{action}</div>}
      </header>
      <div className={styles.body} style={{ height }}>
        {children}
      </div>
    </article>
  );
}
